export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  readTime: string;
  category: string;
  tags: string[];
  featured: boolean;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string;
  imageUrl?: string;
  categories?: string[];
}

export const blogPosts: BlogPost[] = [
  // 2025-06-12 (neuestes Datum)
  {
    id: "19",
    title: "Kaufsucht und ADHS: Wann professionelle Hilfe der richtige Weg ist",
    excerpt: "Wenn Kaufimpulse bei ADHS zur Belastung werden: Informationen über Unterstützungsmöglichkeiten und den Weg zu professioneller Hilfe ohne Stigma.",
    slug: "kaufsucht-adhs-professionelle-hilfe-unterstützung",
    date: "2025-06-12",
    author: "KaufPause Team",
    readTime: "8 min",
    category: "ADHS",
    tags: ["Kaufsucht", "ADHS", "Therapie", "Unterstützung"],
    featured: false,
    seoTitle: "Kaufsucht und ADHS: Wann professionelle Hilfe der richtige Weg ist",
    seoDescription: "Verstehen Sie, wann bei ADHS und problematischem Kaufverhalten professionelle Hilfe sinnvoll ist. Wege zu Unterstützung ohne Stigma und mit Verständnis.",
    seoKeywords: "Kaufsucht ADHS, ADHS professionelle Hilfe, ADHS Therapie, Kaufsucht Behandlung, ADHS Unterstützung, problematisches Kaufverhalten ADHS",
    imageUrl: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2070&auto=format&fit=crop",
    categories: ["ADHS", "Kaufsucht"],
    content: ""
  },
  {
    id: "10",
    title: "Finanzielle Bildung für Generation Z: Bewusster Konsum in der digitalen Welt",
    excerpt: "Wie junge Menschen in einer von Werbung und Social Media geprägten Welt finanzielle Kompetenz entwickeln und bewusste Kaufentscheidungen treffen können.",
    slug: "finanzielle-bildung-generation-z-bewusster-konsum-digital",
    date: "2025-06-12",
    author: "Julia Berger",
    readTime: "8 min",
    category: "Finanzbildung",
    tags: ["Generation Z", "Finanzielle Bildung", "Digitale Welt", "Bewusster Konsum", "Junge Erwachsene"],
    featured: false,
    seoTitle: "Finanzielle Bildung für Generation Z: Bewusster Konsum in der digitalen Welt",
    seoDescription: "Wie junge Menschen finanzielle Kompetenz entwickeln und in einer von Social Media geprägten Welt bewusste Kaufentscheidungen treffen können.",
    seoKeywords: "finanzielle Bildung Generation Z, bewusster Konsum digital, junge Erwachsene Finanzen, Social Media Konsum, digitale Finanzbildung",
    imageUrl: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?q=80&w=2070&auto=format&fit=crop",
    categories: ["Finanzbildung", "Generation Z"],
    content: ""
  },
  // 2025-06-11
  {
    id: "18",
    title: "ADHS im Erwachsenenalter: Kaufimpulse im Alltag bewältigen",
    excerpt: "Erwachsene mit ADHS erleben oft besondere Herausforderungen bei alltäglichen Kaufentscheidungen. Praktische Alltagsstrategien für bewussteres Konsumverhalten.",
    slug: "adhs-erwachsene-kaufimpulse-alltag-bewältigung",
    date: "2025-06-11",
    author: "KaufPause Team",
    readTime: "7 min",
    category: "ADHS",
    tags: ["ADHS Erwachsene", "Alltagsbewältigung", "Kaufimpulse", "30-Tage-Regel"],
    featured: false,
    seoTitle: "ADHS im Erwachsenenalter: Kaufimpulse im Alltag bewältigen",
    seoDescription: "Praktische Alltagsstrategien für Erwachsene mit ADHS. Wie Sie Kaufimpulse erkennen, kontrollieren und bewusstere Konsumentscheidungen treffen.",
    seoKeywords: "ADHS Erwachsene, ADHS Alltag, erwachsene ADHS Kaufimpulse, ADHS Alltagsbewältigung, ADHS Kaufverhalten Erwachsene",
    imageUrl: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2070&auto=format&fit=crop",
    categories: ["ADHS", "Erwachsene"],
    content: ""
  },
  {
    id: "9",
    title: "TikTok-Shopping-Falle: Wie Social Commerce junge Erwachsene zum Kaufen verführt",
    excerpt: "Die dunkle Seite von TikTok Shop und Social Commerce. Wie Algorithmen und Influencer junge Menschen zu impulsiven Käufen verleiten.",
    slug: "tiktok-shopping-falle-social-commerce-junge-erwachsene",
    date: "2025-06-11",
    author: "Leon Bauer",
    readTime: "9 min",
    category: "Social Media",
    tags: ["TikTok", "Social Commerce", "Junge Erwachsene", "Influencer Marketing", "Algorithmus"],
    featured: true,
    seoTitle: "TikTok-Shopping-Falle: Wie Social Commerce junge Erwachsene zum Kaufen verführt",
    seoDescription: "Entdecke die Mechanismen hinter TikTok Shop und Social Commerce. Wie Algorithmen und Influencer junge Menschen zu impulsiven Käufen verleiten und wie man sich schützt.",
    seoKeywords: "TikTok Shopping, Social Commerce, junge Erwachsene Impulskäufe, Influencer Marketing, TikTok Shop Falle, Social Media Shopping",
    imageUrl: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=2074&auto=format&fit=crop",
    categories: ["Social Media", "Junge Erwachsene"],
    content: ""
  },
  // 2025-06-10
  {
    id: "17",
    title: "ADHS und Impulskäufe: Verständnis und Bewältigungsstrategien",
    excerpt: "Menschen mit ADHS erleben oft besondere Herausforderungen beim Kaufverhalten. Verstehen Sie die Zusammenhänge und entdecken Sie hilfreiche Strategien für bewusstere Kaufentscheidungen.",
    slug: "adhs-impulskäufe-verstehen-bewältigen-strategien",
    date: "2025-06-10",
    author: "KaufPause Team",
    readTime: "8 min",
    category: "ADHS",
    tags: ["ADHS", "Impulskontrolle", "30-Tage-Regel", "Selbstmanagement"],
    featured: false,
    seoTitle: "ADHS und Impulskäufe: Verständnis und Bewältigungsstrategien",
    seoDescription: "Verstehen Sie die Verbindung zwischen ADHS und Kaufimpulsen. Praktische Strategien und angepasste Methoden für bewusstere Kaufentscheidungen bei ADHS.",
    seoKeywords: "ADHS Impulskäufe, ADHS Kaufverhalten, Impulskontrolle ADHS, ADHS Strategien, bewusster Konsum ADHS, 30-Tage-Regel ADHS",
    imageUrl: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=2070&auto=format&fit=crop",
    categories: ["ADHS", "Impulskäufe"],
    content: ""
  },
  // 2025-06-09
  {
    id: "16",
    title: "Gebraucht kaufen: Nachhaltiger Konsum mit Bedacht",
    excerpt: "Second-Hand-Shopping kann nachhaltig und sparsam sein - aber auch zur Falle werden. Wie Sie beim Gebraucht-Kauf die 30-Tage-Regel anwenden und bewusste Entscheidungen treffen.",
    slug: "gebraucht-kaufen-bewusst-second-hand-shopping",
    date: "2025-06-09",
    author: "KaufPause Team",
    readTime: "7 min",
    category: "Nachhaltigkeit",
    tags: ["Gebraucht kaufen", "Second-Hand", "30-Tage-Regel", "Nachhaltigkeit"],
    featured: false,
    seoTitle: "Gebraucht kaufen: Nachhaltiger Konsum mit Bedacht",
    seoDescription: "Second-Hand-Shopping nachhaltig und bewusst gestalten. Wie Sie die 30-Tage-Regel auch beim Gebraucht-Kauf anwenden und Fallen vermeiden.",
    seoKeywords: "gebraucht kaufen, Second-Hand Shopping, nachhaltiger Konsum, bewusst gebraucht kaufen, Second-Hand Fallen, 30-Tage-Regel",
    imageUrl: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?q=80&w=2070&auto=format&fit=crop",
    categories: ["Nachhaltigkeit", "Second-Hand"],
    content: ""
  },
  {
    id: 'gruppenlizenzen-institutionen-schuldnerberatung',
    title: 'Gruppenlizenzen für Schuldnerberatungen: Wie KaufPause Ihren Klienten beim bewussten Konsum hilft',
    slug: 'gruppenlizenzen-institutionen-schuldnerberatung',
    excerpt: 'Entdecken Sie, wie Schuldnerberatungen, Verbraucherzentralen und soziale Einrichtungen mit KaufPause-Gruppenlizenzen ihre Klienten beim bewussten Umgang mit Geld unterstützen können. Flexible Lösungen, DSGVO-konform und auf Rechnung.',
    content: '',
    author: 'KaufPause Team',
    date: '2025-06-09',
    readTime: '8 min',
    category: 'Institutionen',
    tags: ['Gruppenlizenzen', 'Schuldnerberatung', 'Verbraucherzentrale', 'Bewusster Konsum', 'DSGVO', 'B2B'],
    featured: true,
    seoTitle: 'Gruppenlizenzen für Schuldnerberatungen | KaufPause - Bewusster Konsum für Ihre Klienten',
    seoDescription: 'Flexible KaufPause-Gruppenlizenzen für Schuldnerberatungen und soziale Einrichtungen. DSGVO-konform, auf Rechnung, ab 6,90€/Jahr. Helfen Sie Ihren Klienten beim bewussten Konsum.',
    seoKeywords: 'Gruppenlizenz, Schuldnerberatung, Verbraucherzentrale, bewusster Konsum, Impulskäufe vermeiden, DSGVO, Kauf auf Rechnung, soziale Einrichtungen, Beratungsstellen',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3',
    categories: ['Institutionen', 'B2B']
  },
  {
    id: "7",
    title: "Stress-Shopping: Wenn Druck zu unkontrollierten Impulskäufen führt",
    excerpt: "Wie Stress und emotionale Belastung zu irrationalen Kaufentscheidungen führen. Erkenne die Warnsignale und entwickle gesunde Bewältigungsstrategien.",
    slug: "stress-shopping-druck-unkontrollierte-impulskaufe",
    date: "2025-06-09",
    author: "Dr. Sarah Klein",
    readTime: "7 min",
    category: "Psychologie",
    tags: ["Stress", "Emotionales Kaufen", "Psychologie", "Bewältigung", "Impulskontrolle"],
    featured: false,
    seoTitle: "Stress-Shopping: Wenn Druck zu unkontrollierten Impulskäufen führt",
    seoDescription: "Verstehe den Zusammenhang zwischen Stress und Impulskäufen. Lerne Warnsignale zu erkennen und entwickle gesunde Strategien gegen emotionales Shopping.",
    seoKeywords: "Stress-Shopping, emotionale Impulskäufe, Stress bewältigen, Kaufsucht, emotionales Kaufen, Impulskontrolle",
    imageUrl: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?q=80&w=2070&auto=format&fit=crop",
    categories: ["Psychologie", "Stress"],
    content: ""
  },
  // 2025-06-08
  {
    id: "15",
    title: "Nacht-Shopping: Wenn die Spätstunden zum Kaufrausch werden",
    excerpt: "Warum Online-Shopping nachts besonders verlockend ist und wie Sie ungewollte Impulskäufe in den späten Stunden vermeiden. Praktische Tipps gegen nächtliche Kaufimpulse.",
    slug: "nacht-shopping-online-spätestunden-impulskäufe",
    date: "2025-06-08",
    author: "KaufPause Team",
    readTime: "5 min",
    category: "Online-Shopping",
    tags: ["Nacht-Shopping", "Online-Käufe", "30-Tage-Regel", "Schlafqualität"],
    featured: false,
    seoTitle: "Nacht-Shopping: Wenn die Spätstunden zum Kaufrausch werden",
    seoDescription: "Entdecken Sie, warum nächtliches Online-Shopping so verlockend ist und wie Sie ungewollte Impulskäufe in den späten Stunden vermeiden können.",
    seoKeywords: "Nacht-Shopping, nächtliche Impulskäufe, Online-Shopping nachts, späte Käufe vermeiden, digitale Kaufimpulse, 30-Tage-Regel",
    imageUrl: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=2070&auto=format&fit=crop",
    categories: ["Online-Shopping", "Digitale Gewohnheiten"],
    content: ""
  },
  {
    id: "6",
    title: "Software-Sammler-Syndrom: Warum Selbstständige zu viele Tools kaufen und nie nutzen",
    excerpt: "Das Phänomen der ungenutzten Software-Abonnements bei Freelancern und Selbstständigen. Wie die 30-Tage-Regel vor teuren Tool-Sammlungen schützt.",
    slug: "software-sammler-syndrom-selbststaendige-tools-kaufen-nie-nutzen",
    date: "2025-06-08",
    author: "Michael Schneider",
    readTime: "8 min",
    category: "Freelancer",
    tags: ["Freelancer", "Software", "Selbstständige", "Tool-Management", "Produktivität"],
    featured: true,
    seoTitle: "Software-Sammler-Syndrom: Warum Selbstständige zu viele Tools kaufen und nie nutzen",
    seoDescription: "Entdecke, warum Freelancer und Selbstständige oft unnötige Software kaufen und wie die 30-Tage-Regel vor teuren Tool-Sammlungen schützt. Praktische Tipps für bewusste Tool-Auswahl.",
    seoKeywords: "Software-Sammler-Syndrom, Freelancer Tools, Selbstständige Software, unnötige Abonnements, Tool-Management, 30-Tage-Regel",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
    categories: ["Freelancer", "Software"],
    content: ""
  },
  {
    id: "1",
    title: "Impulskäufe vermeiden: 7 bewährte Strategien für bewussteres Konsumieren",
    excerpt: "Entdecke effektive Strategien, um Impulskäufe zu reduzieren und deine Finanzen nachhaltig zu verbessern. Von der 30-Tage-Regel bis hin zu digitalen Helfertools.",
    slug: "impulskaufe-vermeiden-strategien-bewusstes-konsumieren",
    date: "2025-06-08",
    author: "Julia Berger",
    readTime: "6 min",
    category: "Spartipps",
    tags: ["Spartipps", "Finanzen", "Bewusster Konsum"],
    featured: false,
    seoTitle: "Impulskäufe vermeiden: 7 bewährte Strategien für bewussteres Konsumieren",
    seoDescription: "Entdecke effektive Strategien, um Impulskäufe zu reduzieren und deine Finanzen nachhaltig zu verbessern. Von der 30-Tage-Regel bis hin zu digitalen Helfertools.",
    seoKeywords: "Impulskäufe vermeiden, bewusster Konsum, Spartipps, Finanzen, 30-Tage-Regel",
    imageUrl: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2070&auto=format&fit=crop",
    categories: ["Spartipps", "Finanzen"],
    content: ""
  },
  // 2025-06-07
  {
    id: "14",
    title: "Frust-Shopping: Wenn schlechte Gefühle zum Kaufrausch führen",
    excerpt: "Wie entstehen emotionale Impulskäufe und was hilft gegen Frust-Shopping? Praktische Strategien für bewusste Kaufentscheidungen statt emotionsgetriebener Spontankäufe.",
    slug: "frust-shopping-emotionale-impulskaufe-bewältigen",
    date: "2025-06-07",
    author: "KaufPause Team",
    readTime: "6 min",
    category: "Impulskäufe",
    tags: ["Frust-Shopping", "Emotionale Käufe", "30-Tage-Regel", "Selbstreflexion"],
    featured: false,
    seoTitle: "Frust-Shopping: Wenn schlechte Gefühle zum Kaufrausch führen",
    seoDescription: "Verstehen Sie die Mechanismen des Frust-Shoppings und entwickeln Sie Strategien gegen emotionale Impulskäufe. Praktische Tipps für bewusste Kaufentscheidungen.",
    seoKeywords: "Frust-Shopping, emotionale Impulskäufe, Retail-Therapie, emotionales Kaufen, bewusste Kaufentscheidungen, 30-Tage-Regel",
    imageUrl: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=2070&auto=format&fit=crop",
    categories: ["Impulskäufe", "Psychologie"],
    content: ""
  },
  {
    id: "8",
    title: "Minimalismus vs. Realität: Warum auch bewusste Konsumenten in Kauffallen tappen",
    excerpt: "Selbst überzeugte Minimalisten sind nicht immun gegen Impulskäufe. Eine ehrliche Betrachtung der Herausforderungen beim bewussten Konsum.",
    slug: "minimalismus-realitaet-bewusste-konsumenten-kauffallen",
    date: "2025-06-07",
    author: "Anna Richter",
    readTime: "6 min",
    category: "Minimalismus",
    tags: ["Minimalismus", "Bewusster Konsum", "Kauffallen", "Selbstreflexion", "Konsumkritik"],
    featured: false,
    seoTitle: "Minimalismus vs. Realität: Warum auch bewusste Konsumenten in Kauffallen tappen",
    seoDescription: "Eine ehrliche Betrachtung der Herausforderungen beim bewussten Konsum. Warum selbst überzeugte Minimalisten manchmal in Kauffallen tappen und wie man damit umgeht.",
    seoKeywords: "Minimalismus Realität, bewusster Konsum Herausforderungen, Kauffallen Minimalisten, Konsumkritik, Selbstreflexion",
    imageUrl: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?q=80&w=2070&auto=format&fit=crop",
    categories: ["Minimalismus", "Konsumkritik"],
    content: ""
  },
  // 2025-06-06
  {
    id: "13",
    title: "Kaufimpulse erkennen und tracken: Der Weg zu bewussten Entscheidungen",
    excerpt: "Wie Sie Ihre Kaufimpulse bewusst wahrnehmen, dokumentieren und verstehen lernen. Praktische Methoden für mehr Selbstreflexion und kontrollierte Kaufentscheidungen.",
    slug: "kaufimpulse-erkennen-tracking-bewusste-entscheidungen",
    date: "2025-06-06",
    author: "KaufPause Team",
    readTime: "6 min",
    category: "Selbstreflexion",
    tags: ["Kaufimpulse", "Tracking", "30-Tage-Regel", "Selbstbeobachtung"],
    featured: false,
    seoTitle: "Kaufimpulse erkennen und tracken: Der Weg zu bewussten Entscheidungen",
    seoDescription: "Lernen Sie, Ihre Kaufimpulse bewusst wahrzunehmen und zu dokumentieren. Praktische Tracking-Methoden für mehr Selbstreflexion und kontrollierte Kaufentscheidungen.",
    seoKeywords: "Kaufimpulse erkennen, Impulskauf tracking, bewusste Kaufentscheidungen, Selbstreflexion, 30-Tage-Regel, Kaufverhalten analysieren",
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop",
    categories: ["Selbstreflexion", "Impulskäufe"],
    content: ""
  },
  {
    id: "2",
    title: "Die Psychologie hinter Impulskäufen: Warum wir kaufen, was wir nicht brauchen",
    excerpt: "Ein tiefer Einblick in die psychologischen Trigger, die zu Impulskäufen führen und wie Unternehmen diese gezielt nutzen. Lerne, diese Mechanismen zu erkennen.",
    slug: "psychologie-impulskaufe-warum-kaufen-ohne-bedarf",
    date: "2025-06-06",
    author: "Dr. Thomas Müller",
    readTime: "8 min",
    category: "Psychologie",
    tags: ["Psychologie", "Konsumverhalten", "Marketing"],
    featured: false,
    seoTitle: "Die Psychologie hinter Impulskäufen: Warum wir kaufen, was wir nicht brauchen",
    seoDescription: "Ein tiefer Einblick in die psychologischen Trigger, die zu Impulskäufen führen und wie Unternehmen diese gezielt nutzen. Lerne, diese Mechanismen zu erkennen.",
    seoKeywords: "Psychologie Impulskäufe, Konsumverhalten, Marketing Tricks, unbewusster Konsum",
    imageUrl: "https://images.unsplash.com/photo-1483985988355-763728e1935b?q=80&w=800&auto=format&fit=crop",
    categories: ["Psychologie", "Konsumverhalten"],
    content: ""
  },
  // 2025-06-05
  {
    id: "11",
    title: "Subscription-Trap: Wenn Abo-Modelle zur finanziellen Belastung werden",
    excerpt: "Die versteckten Kosten von Abonnement-Diensten und wie sie sich unbemerkt summieren. Strategien für ein bewusstes Abo-Management.",
    slug: "subscription-trap-abo-modelle-finanzielle-belastung",
    date: "2025-06-05",
    author: "Thomas Wagner",
    readTime: "7 min",
    category: "Finanzen",
    tags: ["Abonnements", "Subscription", "Finanzen", "Kostenkontrolle", "Abo-Management"],
    featured: false,
    seoTitle: "Subscription-Trap: Wenn Abo-Modelle zur finanziellen Belastung werden",
    seoDescription: "Entdecke die versteckten Kosten von Abonnement-Diensten und lerne Strategien für ein bewusstes Abo-Management. Schütze dich vor der Subscription-Falle.",
    seoKeywords: "Subscription Trap, Abo-Modelle Kosten, Abonnement-Falle, Abo-Management, versteckte Kosten, Subscription Dienste",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2070&auto=format&fit=crop",
    categories: ["Finanzen", "Abonnements"],
    content: ""
  },
  // 2025-06-04
  {
    id: "3",
    title: "Minimalistischer Lebensstil: Mehr Zufriedenheit durch bewussten Konsum",
    excerpt: "Wie ein reduzierter Lebensstil nicht nur deinen Geldbeutel schont, sondern auch zu mehr Lebensqualität und Zufriedenheit führen kann.",
    slug: "minimalistischer-lebensstil-zufriedenheit-bewusster-konsum",
    date: "2025-06-04",
    author: "Lisa Hoffmann",
    readTime: "7 min",
    category: "Minimalismus",
    tags: ["Minimalismus", "Lifestyle", "Zufriedenheit"],
    featured: false,
    seoTitle: "Minimalistischer Lebensstil: Mehr Zufriedenheit durch bewussten Konsum",
    seoDescription: "Wie ein reduzierter Lebensstil nicht nur deinen Geldbeutel schont, sondern auch zu mehr Lebensqualität und Zufriedenheit führen kann.",
    seoKeywords: "Minimalismus, bewusster Konsum, Zufriedenheit, Lebensqualität, weniger ist mehr",
    imageUrl: "https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?q=80&w=800&auto=format&fit=crop",
    categories: ["Minimalismus", "Lifestyle"],
    content: ""
  },
  // 2025-06-03
  {
    id: "12",
    title: "FOMO-Shopping: Wenn die Angst etwas zu verpassen zum Kaufzwang wird",
    excerpt: "Fear of Missing Out (FOMO) als treibende Kraft hinter impulsiven Kaufentscheidungen. Wie limitierte Angebote und Zeitdruck manipulieren.",
    slug: "fomo-shopping-angst-verpassen-kaufzwang",
    date: "2025-06-03",
    author: "Dr. Sarah Klein",
    readTime: "6 min",
    category: "Psychologie",
    tags: ["FOMO", "Fear of Missing Out", "Kaufzwang", "Limitierte Angebote", "Zeitdruck"],
    featured: false,
    seoTitle: "FOMO-Shopping: Wenn die Angst etwas zu verpassen zum Kaufzwang wird",
    seoDescription: "Verstehe wie Fear of Missing Out (FOMO) zu impulsiven Käufen führt. Erkenne Manipulationstechniken und entwickle Strategien gegen FOMO-Shopping.",
    seoKeywords: "FOMO Shopping, Fear of Missing Out, Kaufzwang, limitierte Angebote, Zeitdruck Marketing, FOMO Psychologie",
    imageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=2070&auto=format&fit=crop",
    categories: ["Psychologie", "FOMO"],
    content: ""
  },
  // 2025-06-02
  {
    id: "4",
    title: "Digitale Tools für Freelancer: Was wirklich notwendig ist und wovon du die Finger lassen solltest",
    excerpt: "Eine kritische Betrachtung von Software und digitalen Abonnements für Selbstständige. Welche Investitionen lohnen sich wirklich und welche sind verzichtbar?",
    slug: "digitale-tools-freelancer-notwendig-verzichtbar",
    date: "2025-06-02",
    author: "Markus Weber",
    readTime: "10 min",
    category: "Freelancer",
    tags: ["Freelancer", "Digitale Tools", "Software", "Produktivität"],
    featured: false,
    seoTitle: "Digitale Tools für Freelancer: Was wirklich notwendig ist und wovon du die Finger lassen solltest",
    seoDescription: "Eine kritische Betrachtung von Software und digitalen Abonnements für Selbstständige. Welche Investitionen lohnen sich wirklich und welche sind verzichtbar?",
    seoKeywords: "Freelancer Tools, digitale Software, Selbstständige, Produktivität, notwendige Tools",
    imageUrl: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800&auto=format&fit=crop",
    categories: ["Freelancer", "Digitale Tools"],
    content: ""
  },
  // 2025-05-30
  {
    id: "5",
    title: "Nachhaltig sparen: Wie umweltbewusstes Konsumieren auch deinem Geldbeutel hilft",
    excerpt: "Entdecke den doppelten Vorteil nachhaltigen Konsums: Schone die Umwelt und spare gleichzeitig Geld durch bewusste Kaufentscheidungen.",
    slug: "nachhaltig-sparen-umweltbewusstes-konsumieren-geldbeutel",
    date: "2025-05-30",
    author: "Sophie Neumann",
    readTime: "9 min",
    category: "Nachhaltigkeit",
    tags: ["Nachhaltigkeit", "Spartipps", "Umweltschutz", "Bewusster Konsum"],
    featured: false,
    seoTitle: "Nachhaltig sparen: Wie umweltbewusstes Konsumieren auch deinem Geldbeutel hilft",
    seoDescription: "Entdecke den doppelten Vorteil nachhaltigen Konsums: Schone die Umwelt und spare gleichzeitig Geld durch bewusste Kaufentscheidungen.",
    seoKeywords: "nachhaltig sparen, umweltbewusst konsumieren, Geld sparen, Nachhaltigkeit, bewusster Konsum",
    imageUrl: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?q=80&w=800&auto=format&fit=crop",
    categories: ["Nachhaltigkeit", "Spartipps"],
    content: ""
  }
]; 